<template>
  <div>
    <v-container fluid class="d-print-none">
      <v-row no-gutters>
        <v-col :cols="6">
          <h1 class="headline font-weight-light mb-3">
            Norm
          </h1>
        </v-col>
        <v-col :cols="6" class="text-right"> </v-col>
      </v-row>

      <v-card>
        <v-card-title>
          <v-row class="mar-t-20">
            <v-col cols="6" md="4"
              ><v-text-field
                v-model="form.searchtext"
                append-icon="mdi-magnify"
                label="Search"
                @keyup="searchProject($event.target.value)"
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <v-btn
                x-small
                fab
                class="mt-4"
                @click="reset()"
                v-if="form.searchtext != ''"
              >
                <v-icon>mdi-rotate-left</v-icon>
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>

            <v-col cols="5" class="text-right mt-5">
              <v-btn color="success" dark small rounded @click="exportexcel()">
                <v-icon small class="mr-1">mdi-file-excel</v-icon>
                Export
              </v-btn>
              <v-btn
                color="primary"
                dark
                small
                rounded
                @click="change_stock_in()"
              >
                <v-icon small class="mr-1">mdi-plus</v-icon>
                Stock in new part
              </v-btn></v-col
            >
          </v-row>
        </v-card-title>

        <v-simple-table class="table-inv mar-t-10">
          <template v-slot:default>
            <thead>
              <tr class="col-tr-1">
                <th class="text-center">Part Description</th>
                <th class="text-center">Location</th>
                <th class="text-center">Qty</th>
                <th class="text-center">Stock In</th>
                <th class="text-center">Log</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in data_stock.data" :key="item.part_id">
                <td class="pa-2">
                  <div v-if="item.part_description" class="font-weight-medium">
                    <span v-if="item.part_description.length < 50">
                      {{ item.part_description }}
                    </span>
                    <span v-else>
                      {{ item.part_description.substring(0, 50) + "..." }}
                    </span>
                  </div>

                  <span class="font-weight-medium  primary--text">{{
                    item.part_name
                  }}</span>
                  <v-chip dense x-small class="ml-2" v-if="item.category_name">
                    {{ item.category_name }}
                  </v-chip>
                  <v-btn x-small fab class="ml-2" @click="open_form_edit(item)">
                    <v-icon small color="primary">mdi-pencil</v-icon>
                  </v-btn>
                </td>
                <td>
                  <v-btn
                    @click="change_location(item.location, item.norm_id)"
                    small
                    >{{ item.location }}</v-btn
                  >
                </td>
                <td class="text-center">
                  <v-badge
                    bordered
                    color="success"
                    :icon="item.onhand"
                    overlap
                    class="mr-4"
                  >
                    <v-btn
                      class="white--text mr-1 ml-1"
                      color="success"
                      depressed
                      x-small
                    >
                      ONHAND
                    </v-btn>
                  </v-badge>

                  <v-badge
                    bordered
                    color="error"
                    :icon="item.loan"
                    overlap
                    class="mr-4"
                    v-if="item.loan > 0"
                  >
                    <v-btn
                      class="white--text mr-1"
                      color="error"
                      depressed
                      x-small
                    >
                      LOAN
                    </v-btn>
                  </v-badge>
                </td>
                <td class="text-center">
                  <v-btn
                    x-small
                    fab
                    @click="open_stock_in(item.norm_id)"
                    color="primary"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </td>
                <td class="text-center">
                  <v-btn
                    x-small
                    fab
                    @click="change_detail(item.norm_id)"
                    color="light-blue accent-1"
                  >
                    <v-icon>mdi-table-edit</v-icon>
                  </v-btn>
                </td>
              </tr>
              <br />
            </tbody>
          </template>
        </v-simple-table>

        <div class="text-center pb-5 pt-4">
          <div>
            <v-btn
              class="mx-2"
              fab
              small
              @click="back()"
              :disabled="page_count == 1"
            >
              <v-icon dark>mdi-chevron-left</v-icon>
            </v-btn>

            <v-btn
              class="mx-2"
              fab
              small
              :color="btn_color(n)"
              v-for="n in page_count"
              :key="n"
              @click="get_stock_page(page_num_show(n))"
            >
              {{ page_num_show(n) }}
            </v-btn>

            <v-btn class="mx-2" fab small @click="next()">
              <v-icon dark>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-container>

    <v-row justify="center">
      <v-form method="post" id="nativeForm" v-model="valid">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Stock in new part</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col class="mar-t-10" cols="12">
                    <v-text-field
                      outlined
                      dense
                      label="Part Name"
                      v-model="form_stock_in.part_name"
                      :rules="part_nameR"
                    ></v-text-field>
                  </v-col>
                  <v-col class="mar-t-10" cols="12">
                    <v-text-field
                      outlined
                      dense
                      :rules="part_descriptionR"
                      label="Part Description"
                      v-model="form_stock_in.part_description"
                    ></v-text-field>
                  </v-col>
                  <v-col class="mar-t-10" cols="12" md="6">
                    <v-text-field
                      outlined
                      dense
                      :rules="qtyR"
                      label="Qty"
                      v-model="form_stock_in.qty"
                    ></v-text-field>
                  </v-col>
                  <v-col class="mar-t-10" cols="12" md="6">
                    <v-text-field
                      outlined
                      dense
                      :rules="shipmentR"
                      label="Shipment"
                      v-model="form_stock_in.shipment"
                    ></v-text-field>
                  </v-col>
                  <v-col class="mar-t-10" cols="12" md="6">
                    <v-text-field
                      outlined
                      dense
                      :rules="locationR"
                      label="Location"
                      v-model="form_stock_in.location"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="mar-t-30">
              <v-btn color="blue darken-1" text @click="close_stock_in()">
                Close
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                @click="save_stock_in()"
                :disabled="!valid"
                class="success"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>
    </v-row>

    <v-row justify="center">
      <v-dialog
        v-model="dialogDetail"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closedialogDetail()">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-toolbar-title>{{ form.case_id }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="6" md="4">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                ></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="6" class="mt-4 text-right">
                <v-btn
                  color="primary"
                  dark
                  small
                  rounded
                  class="mb-2"
                  @click="func_issue_tranfers()"
                  >Issue / Tranfers</v-btn
                >
              </v-col>
              <v-col cols="12" class="mar-t-30">
                <v-data-table
                  :headers="headers"
                  :items="data_transaction"
                  :search="search"
                  :loading="isLoading"
                  loading-text="Loading... Please wait"
                >
                  <template v-slot:[`item.caseid`]="{ item }">
                    <v-chip v-if="item.caseid != '' && item.caseid != null"
                      >{{ item.caseid }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.return_name`]="{ item }">
                    <v-chip
                      small
                      color="light-blue accent-1"
                      class="mt-1"
                      v-if="item.return_name != '' && item.return_name != null"
                      >{{ item.return_name }}</v-chip
                    ><br />
                    <v-chip
                      small
                      class="mt-1"
                      v-if="item.return_date != '' && item.return_date != null"
                      >{{ item.return_date }}</v-chip
                    >
                  </template>
                  <template
                    class="text-center"
                    v-slot:[`item.transaction_id`]="{
                      item,
                    }"
                  >
                    <v-chip
                      small
                      color="teal accent-4"
                      class="mt-1"
                      v-if="
                        item.transaction_name != '' &&
                          item.transaction_name != null
                      "
                      >{{ item.transaction_name }}</v-chip
                    ><br />
                    <v-chip small class="mt-1">{{
                      item.transaction_date
                    }}</v-chip>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      v-if="item.type == 'Loan'"
                      fab
                      small
                      color="amber"
                      @click="func_action(item.transaction_id)"
                    >
                      <v-icon>mdi-pencil-circle</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-dialog v-model="dialog2" max-width="500px">
      <v-form method="post" id="nativeForm" v-model="valid2">
        <v-card>
          <v-card-title>
            Issue / Tranfers
          </v-card-title>
          <v-card-text>
            <v-select
              :items="['Loan', 'Transfer']"
              label="Select List"
              item-value="text"
              :rules="typeR"
              v-model="form_save.type"
            ></v-select>
            <v-text-field
              v-if="form_save.type == 'Loan'"
              small
              label="Case ID"
              :rules="caseidR"
              v-model="form_save.caseid"
            ></v-text-field>
            <v-text-field
              v-if="form_save.type == 'Loan'"
              small
              label="Engineer"
              :rules="engineerR"
              v-model="form_save.engineer"
            ></v-text-field>

            <v-text-field
              v-if="form_save.type == 'Transfer'"
              small
              label="QTY"
              :rules="qtyR2"
              v-model="form_save.qty"
            ></v-text-field>
            <v-text-field
              small
              label="Remark"
              :rules="remarkR"
              v-model="form_save.remark"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="close_issue_tranfers()" text>
              Close
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              @click="save_issue_tranfers()"
              color="success"
              :disabled="!valid2"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dialog3" max-width="500px">
      <v-form method="post" id="nativeForm" v-model="valid3">
        <v-card>
          <v-card-title>
            Update Loan
          </v-card-title>
          <v-card-text>
            <v-select
              :items="['Good', 'Defective']"
              label="Select List"
              item-value="text"
              :rules="statusR"
              v-model="form_save2.status"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-btn color="primary" @click="close_func_action()" text>
              Close
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              @click="save_func_action()"
              color="success"
              :disabled="!valid3"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dialog4" max-width="500px">
      <v-form method="post" id="nativeForm" v-model="valid4">
        <v-card>
          <v-card-title>
            Edit Location
          </v-card-title>
          <v-card-text>
            <v-text-field
              small
              label="Location"
              :rules="locationR2"
              v-model="location"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="dialog4 = false" text>
              Close
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              @click="save_edit_location()"
              color="success"
              :disabled="!valid4"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-form method="post" id="nativeForm" v-model="valid5">
      <v-dialog v-model="dialogStockIn" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Stock in new part</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col class="mar-t-10" cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    :rules="qtyR2"
                    label="Qty"
                    v-model="form_stock_in2.qty"
                  ></v-text-field>
                </v-col>
                <v-col class="mar-t-10" cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    :rules="shipmentR2"
                    label="Shipment"
                    v-model="form_stock_in2.shipment"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions class="mar-t-30">
            <v-btn color="blue darken-1" text @click="close_stock_in2()">
              Close
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              @click="save_stock_in2()"
              :disabled="!valid5"
              class="success"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>

    <v-dialog v-model="dialogEdit" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Stock in new part</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="mar-t-10" cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  readonly
                  label="Part name"
                  v-model="data_edit.part_name"
                ></v-text-field>
              </v-col>
              <v-col class="mar-t-10" cols="12" md="6">
                <v-text-field
                  outlined
                  dense
                  label="Part Description"
                  v-model="data_edit.part_description"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="mar-t-30">
          <v-btn color="blue darken-1" text @click="close_edit_part()">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="save_edit_part()" class="success">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div id="snackbar" class="d-print-none">
      <v-snackbar v-model="snackbar" color="success" right>
        {{ text }}
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import { mapState, mapMutations } from "vuex";
import CompBarcode from "./components/Barcode";

const url = `${process.env.VUE_APP_ROOT_API}/api/`;

export default {
  created() {
    this.searchProject = _.debounce(this.searchProject, 300);
  },
  components: {
    CompBarcode: CompBarcode,
  },
  computed: {
    ...mapState(["snackbar"]),
    ...mapState(["isLoading"]),
  },
  beforeMount() {
    this.tk = {
      headers: { Authorization: "Bearer " + localStorage.token },
    };
  },
  mounted() {
    this.get_data();
    if (this.snackbar === true) {
      setTimeout(() => {
        this.mutatesnackbar();
      }, 2000);
    }
  },
  methods: {
    ...mapMutations(["mutatesnackbar"]),
    ...mapMutations(["mutateIsLoading"]),
    async exportexcel() {
      let url_report;
      let data_export;
      let url = `${process.env.VUE_APP_ROOT_API}/api/norm/export/report`;
      await axios({
        url: url,
        method: "GET",
        responseType: "blob",
        data: data_export,
        headers: { Authorization: "Bearer " + localStorage.token },
      }).then((response) => {
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "report.xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
      });
      if (this.snackbar === true) {
        setTimeout(() => {
          this.mutatesnackbar();
        }, 3000);
      }
    },
    async get_data() {
      this.mutateIsLoading();
      this.current_page = this.$route.params.pages;
      if (this.current_page === undefined) {
        this.current_page = 1;
      }
      let url =
        `${process.env.VUE_APP_ROOT_API}/api/norm?page=` + this.current_page;
      await axios.post(url, {}, this.tk).then((response) => {
        this.mutateIsLoading();
        this.data_stock = response.data;
        this.page_total = response.data.last_page;
        this.page_total < 7
          ? (this.page_count = this.page_total)
          : (this.page_count = 7);
      });
    },
    async back() {
      let url = this.data_stock.prev_page_url;
      let { data } = await axios.post(url, {}, this.tk);
      this.data_stock = data;
    },
    async next() {
      let url = this.data_stock.next_page_url;
      let { data } = await axios.post(url, {}, this.tk);
      this.data_stock = data;
    },
    async get_stock_page(num) {
      this.current_page = num;
      if (num != "...") {
        let url = `${process.env.VUE_APP_ROOT_API}/api/norm?page=` + num;
        let { data } = await axios.post(url, {}, this.tk);
        this.data_stock = data;
      }
    },
    btn_color(n) {
      if (this.page_count == 7) {
        if (this.data_stock.current_page <= 4) {
          return this.data_stock.current_page === n ? "primary" : "";
        } else if (this.data_stock.current_page == this.data_stock.last_page) {
          return n === 7 ? "primary" : "";
        } else if (
          this.data_stock.current_page ==
          this.data_stock.last_page - 1
        ) {
          return n === 6 ? "primary" : "";
        } else if (
          this.data_stock.current_page ==
          this.data_stock.last_page - 2
        ) {
          return n === 5 ? "primary" : "";
        } else {
          return n === 4 ? "primary" : "";
        }
      } else {
        return this.data_stock.current_page === n ? "primary" : "";
      }
    },
    page_num_show(n) {
      let page = n;
      if (this.page_count == 7) {
        let chk2 = 0;
        let chk3 = 0;
        let chk4 = 0;
        let chk5 = 0;
        let chk6 = 0;
        if (this.data_stock.current_page == 1) {
          chk2 = 2;
          chk3 = 3;
          chk4 = 4;
          chk5 = "...";
          chk6 = this.data_stock.last_page - 1;
        } else if (this.data_stock.current_page == this.data_stock.last_page) {
          chk2 = 2;
          chk3 = "...";
          chk4 = this.data_stock.last_page - 3;
          chk5 = this.data_stock.last_page - 2;
          chk6 = this.data_stock.last_page - 1;
        } else if (this.data_stock.current_page == 2) {
          chk2 = 2;
          chk3 = 3;
          chk4 = 4;
          chk5 = "...";
          chk6 = this.data_stock.last_page - 1;
        } else if (
          this.data_stock.current_page ==
          this.data_stock.last_page - 1
        ) {
          chk2 = 2;
          chk3 = "...";
          chk4 = this.data_stock.last_page - 3;
          chk5 = this.data_stock.last_page - 2;
          chk6 = this.data_stock.last_page - 1;
        } else if (this.data_stock.current_page == 3) {
          chk2 = 2;
          chk3 = 3;
          chk4 = 4;
          chk5 = "...";
          chk6 = this.data_stock.last_page - 1;
        } else if (
          this.data_stock.current_page ==
          this.data_stock.last_page - 2
        ) {
          chk2 = 2;
          chk3 = "...";
          chk4 = this.data_stock.last_page - 3;
          chk5 = this.data_stock.last_page - 2;
          chk6 = this.data_stock.last_page - 1;
        } else {
          chk2 = "...";
          chk3 = this.data_stock.current_page - 1;
          chk4 = this.data_stock.current_page;
          chk5 = this.data_stock.current_page + 1;
          chk6 = "...";
        }

        n === 1 ? (page = 1) : "";
        n === 2 ? (page = chk2) : "";
        n === 3 ? (page = chk3) : "";
        n === 4 ? (page = chk4) : "";
        n === 5 ? (page = chk5) : "";
        n === 6 ? (page = chk6) : "";
        n === 7 ? (page = this.data_stock.last_page) : "";
      } else {
        n === 1 ? (page = 1) : "";
        n === 2 ? (page = 2) : "";
        n === 3 ? (page = 3) : "";
        n === 4 ? (page = 4) : "";
        n === 5 ? (page = 5) : "";
        n === 6 ? (page = 6) : "";
      }
      return page;
    },
    async searchProject(value) {
      await axios.post(url + "norm", this.form, this.tk).then((response) => {
        this.data_stock = response.data;
        this.page_total = response.data.last_page;
        this.page_total < 7
          ? (this.page_count = this.page_total)
          : (this.page_count = 7);
      });
    },
    reset() {
      this.form.searchtext = "";
      this.get_data();
    },
    change_stock_in() {
      this.dialog = true;
    },
    close_stock_in() {
      this.form_stock_in = {
        part_name: null,
        part_description: null,
        qty: null,
        shipment: null,
        location: null,
      };
      this.dialog = false;
    },

    async save_stock_in() {
      this.mutateIsLoading();
      await axios
        .post(url + "norm/stock-in", this.form_stock_in, this.tk)
        .then((response) => {
          this.mutatesnackbar();
          this.get_data();
          this.close_stock_in();
          this.mutateIsLoading();
          if (this.snackbar === true) {
            setTimeout(() => {
              this.mutatesnackbar();
            }, 3000);
          }
        });
    },
    async change_detail(norm_id) {
      this.norm_id = norm_id;
      this.mutateIsLoading();
      await axios
        .get(url + "norm/transaction/" + norm_id, this.tk)
        .then((response) => {
          this.mutateIsLoading();
          this.data_transaction = response.data;
          this.dialogDetail = true;
        });
    },

    closedialogDetail() {
      this.dialogDetail = false;
      if (this.count_save > 0) {
        this.get_data();
      }
    },
    func_issue_tranfers() {
      this.dialog2 = true;
    },
    close_issue_tranfers() {
      this.form_save.type = "";
      this.form_save.caseid = "";
      this.form_save.engineer = "";
      this.form_save.remark = "";
      this.form_save.qty = "";
      this.dialog2 = false;
    },
    async save_issue_tranfers() {
      this.mutateIsLoading();
      await axios
        .post(url + "norm/save-loan/" + this.norm_id, this.form_save, this.tk)
        .then((response) => {
          this.count_save += 1;
          this.mutatesnackbar();
          this.change_detail(this.norm_id);
          this.close_issue_tranfers();
          this.mutateIsLoading();
          if (this.snackbar === true) {
            setTimeout(() => {
              this.mutatesnackbar();
            }, 3000);
          }
        });
    },
    func_action(transaction_id) {
      this.transaction_id = transaction_id;
      this.dialog3 = true;
    },
    close_func_action() {
      this.form_save2.status = null;
      this.dialog3 = false;
    },
    async save_func_action() {
      this.mutateIsLoading();
      await axios
        .post(
          url + "norm/update-loan/" + this.transaction_id,
          this.form_save2,
          this.tk
        )
        .then((response) => {
          this.count_save += 1;
          this.mutatesnackbar();
          this.close_func_action();
          this.change_detail(this.norm_id);
          this.mutateIsLoading();
          if (this.snackbar === true) {
            setTimeout(() => {
              this.mutatesnackbar();
            }, 3000);
          }
        });
    },
    change_location(location, norm_id) {
      this.norm_id = norm_id;
      this.location = location;
      this.dialog4 = true;
    },
    async save_edit_location() {
      this.mutateIsLoading();
      let save = {
        location: this.location,
      };
      await axios
        .post(url + "norm/update-location/" + this.norm_id, save, this.tk)
        .then((response) => {
          this.mutatesnackbar();
          this.get_data();
          this.dialog4 = false;
          this.mutateIsLoading();
          if (this.snackbar === true) {
            setTimeout(() => {
              this.mutatesnackbar();
            }, 3000);
          }
        });
    },
    open_stock_in(norm_id) {
      this.form_stock_in2.norm_id = norm_id;
      this.dialogStockIn = true;
    },
    close_stock_in2() {
      this.form_stock_in2 = {
        qty: null,
        shipment: null,
        norm_id: null,
      };
      this.dialogStockIn = false;
    },
    async save_stock_in2() {
      this.mutateIsLoading();
      await axios
        .post(url + "norm/stock-in-part", this.form_stock_in2, this.tk)
        .then((response) => {
          this.mutatesnackbar();
          this.get_data();
          this.close_stock_in2();
          this.mutateIsLoading();
          if (this.snackbar === true) {
            setTimeout(() => {
              this.mutatesnackbar();
            }, 3000);
          }
        });
    },
    open_form_edit(data) {
      this.data_edit = data;
      this.dialogEdit = true;
    },
    async save_edit_part() {
      this.mutateIsLoading();
      await axios
        .post(url + "norm/edit-part", this.data_edit, this.tk)
        .then((response) => {
          this.mutatesnackbar();
          this.get_data();
          this.close_edit_part();
          this.mutateIsLoading();
          if (this.snackbar === true) {
            setTimeout(() => {
              this.mutatesnackbar();
            }, 3000);
          }
        });
    },
    close_edit_part() {
      this.data_edit = [];
      this.dialogEdit = false;
    },
  },
  data() {
    return {
      data_edit: [],
      location: null,
      count_save: 0,
      norm_id: 0,
      transaction_id: 0,
      data_stock: [],
      data_transaction: [],
      page: 1,
      page_total: 0,
      page_count: 0,
      search: "",
      current_page: 0,
      text: "Success, Your work has been saved",
      dialog: false,
      dialogDetail: false,
      dialogStockIn: false,
      dialogEdit: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      form: {
        searchtext: "",
      },
      team_name: localStorage.team_name,
      tk: null,
      valid: false,
      valid2: false,
      valid3: false,
      valid4: false,
      valid5: false,
      form_save: {
        type: null,
        remark: null,
      },
      form_save2: {
        status: null,
      },
      form_stock_in: {
        part_name: null,
        part_description: null,
        qty: null,
        shipment: null,
        location: null,
      },
      form_stock_in2: {
        qty: null,
        shipment: null,
        norm_id: null,
      },
      part_nameR: [(v) => !!v || "Part Name is required"],
      part_descriptionR: [(v) => !!v || "Part Description is required"],
      qtyR: [
        (v) => !!v || "Qty is required",
        (v) => /^\d+$/.test(v) || "Qty be a number",
      ],
      shipmentR: [(v) => !!v || "Shipment is required"],
      qtyR2: [
        (v) => !!v || "Qty is required",
        (v) => /^\d+$/.test(v) || "Qty be a number",
      ],
      shipmentR2: [(v) => !!v || "Shipment is required"],
      locationR: [(v) => !!v || "Location is required"],
      search: "",
      typeR: [(v) => !!v || "type is required"],
      caseidR: [(v) => !!v || "caseid is required"],
      engineerR: [(v) => !!v || "engineer is required"],
      qtyR2: [
        (v) => !!v || "qty is required",
        (v) => /^\d+$/.test(v) || "Qty be a number",
      ],
      remarkR: [(v) => !!v || "remark is required"],
      statusR: [(v) => !!v || "status is required"],
      locationR2: [(v) => !!v || "location is required"],
      headers: [
        {
          text: "TRANSACTION",
          value: "transaction_id",
          class: "text-uppercase darken-3 black--text body-2 text-center",
        },
        {
          text: "TYPE",
          value: "type",
          class: "text-uppercase darken-3 black--text body-2 text-center",
        },
        {
          text: "QTY",
          value: "qty",
          class: "text-uppercase darken-3 black--text body-2",
        },
        {
          text: "SHIPMENT",
          value: "shipment",
          class: "text-uppercase darken-3 black--text body-2",
        },
        {
          text: "CASE ID",
          value: "caseid",
          class: "text-uppercase darken-3 black--text body-2 text-center",
        },
        {
          text: "ENGINEER",
          value: "engineer",
          class: "text-uppercase darken-3 black--text body-2",
        },
        {
          text: "RETURN",
          value: "return_name",
          class: "text-uppercase darken-3 black--text body-2 text-center",
        },

        {
          text: "REMARK",
          value: "remark",
          class: "text-uppercase darken-3 black--text body-2",
        },
        {
          text: "ACTION",
          value: "action",
          class: "text-uppercase darken-3 black--text body-2 text-center",
        },
      ],
    };
  },
};
</script>
